$.fn.sliderOverflow = function(){
	var scope = this,
		items = this.children(),
		$slider = this.flickity({
			pageDots:false,
			cellAlign:'left',
			prevNextButtons:false,
			contain:true,
			freeScroll:true,
			draggable:true,
			imagesLoaded:true
		});
	var slNav = $('<input>',{
			type:'range',
			class:'slider-overflow-nav',
			"aria-label": "Slider Drag Control",
			value:0
		});
	scope.after(slNav);
	var currentSlide = 0,
		isScrubbing = false;
	slNav.on('input',function(){
		isScrubbing = true;
		var scale = 100 / items.length,
			set = Math.floor($(this).val() / scale);
		if(set != currentSlide && set != items.length){
			$slider.flickity('select',set);
			currentSlide = set;
		}
	}).on('mousedown',function(){
		isScrubbing = true;
	}).on('mouseup',function(){
		isScrubbing = false;
	});
	$slider.on( 'scroll.flickity', function( event, progress ) {
		if(!isScrubbing){
			progress = Math.max( 0, Math.min( 1, progress ) );
			slNav.val( progress * 100);
		}
	});
}

$(function(){
	var listOptions = $('ul.list-options');
	listOptions.each(function(){
		var items = $(this).children();
		if(items.first().offset().top != items.last().offset().top){
			$(this).sliderOverflow();
		}
	});
	// SLIDER BASIC
	$('.slider-basic').each(function(){
		var scope = $(this),
			items = scope.find('.slider-basic-item'),
			$slider = $(this).flickity({
				pageDots:false,
				cellAlign:'left',
				prevNextButtons:false,
				contain:true,
				freeScroll:false,
				wrapAround:true,
				draggable:true,
				imagesLoaded:true
			}),
			$prev = $('<button>',{class:'slider-basic-prev'}),
			$next = $('<button>',{class:'slider-basic-next'}),
			$status = $('<span>',{class:'slider-basic-status'}),
			$slNav = $('<div>',{class:'slider-basic-nav'});
		$prev.appendTo($slNav);
		$status.appendTo($slNav);
		$next.appendTo($slNav);
		$prev.click(function(){
			$slider.flickity('previous')
		});
		$next.click(function(){
			$slider.flickity('next')
		});
		// $slider.flickity('select',function(event,index){
		// 	alert()
		// 	$status.text(index + '/' + items.length);
		// });
		$slider.on( 'select.flickity', function(){
			$status.text( $slider.data('flickity').selectedIndex + 1 + '/' + items.length);
		});
		scope.append($slNav);
	});
});